/**
 * Given a type that might be an array of T, returns either T[] or an [], where
 * [] is the type of an empty array of T.
 *
 * @example
 * const subject: Partial<{ yo: string[] }> | undefined = {};
 * const test123: string[] = subjectOrEmptyArrayOfSameType(subject?.yo);
 */
export function subjectOrEmptyArrayOfSameType<T>(
  subject: T[] | undefined | null
): T[] {
  if (Array.isArray(subject)) {
    return subject;
  }

  if (subject === undefined || subject === null) {
    return [];
  }

  return subject || [];
}
